import getIn from 'transmute/getIn';
export const getMobile = getIn(['mobile']);